import { createContext, PropsWithChildren } from 'react';
import { UserSetting } from 'src/WebApiController';

type UserSettingsMap = {
  [key in keyof typeof UserSetting]?: string;
};

type ISellerUserAllSettingsContext = {
  queryResult?: UserSettingsMap | null;
  contextSettingIds?: UserSetting[];
  contextQueryKey?: (string | boolean | UserSetting[] | undefined)[];
  isLoading?: boolean;
  refresh?: () => void;
} | null;

export const SellerUserAllSettingsContext =
  createContext<ISellerUserAllSettingsContext>(null);

export const SellerUserAllSettingsProvider = ({
  children,
}: PropsWithChildren) => {
  return (
    <SellerUserAllSettingsContext.Provider value={null}>
      {children}
    </SellerUserAllSettingsContext.Provider>
  );
};
